<template>
    <div :id="this.$route.name">
        <Card back>
            <template v-slot:header>
                <h4 class="d-inline" v-if="catsName == null">پاسخ های آماده تیکت ها </h4>
                <h4 class="d-inline" v-if="catsName != null">پاسخ های آماده تیکت ها ({{catsName}})</h4>
                <hr />
            </template>
            <template v-slot:content>
                <h3>
                    <i class="px-3"
                        :class="[showAdd ? ['fas', 'fa-times', 'text-danger'] : ['fad', 'fa-plus-circle', 'text-success']]"
                        @click="fasClick()"></i>
                    <button class="btn float-left" @click="backToCatsPage" v-if="!isCatsPage">بازگشت</button>
                </h3>
                <div v-if="showAdd" id="menuForm">

                    <div class="row" v-if="isCatsPage">
                        <div class="col-lg-8 col-12 ">
                            <small class="text-right mt-4" id="LblcatName">نام دسته بندی</small>
                            <input @keypress="$ValidLenght($event, 50)" type="text" v-model="cat.catName"
                                class="form-control required" dir="rtl" />
                        </div>
                        <div class="col-lg-4 col-12" v-if="!isEdit">
                            <button class=" btn btn-success mt-4" @click="SaveCat()">ثـبـت</button>
                        </div>
                        <div class="col-lg-4 col-12" v-else>
                            <button class=" btn btn-warning  mt-4" @click="applyEdit()">ویرایش</button>
                        </div>
                    </div>

                    <div class="row" v-else>
                        <div class="col-lg-8 col-12 ">
                            <small class="text-right mt-4" id="Lblsubject">موضوع</small>
                            <input @keypress="$ValidLenght($event, 50)" type="text" v-model="rep.subject"
                                class="form-control required" dir="rtl" />
                        </div>
                        <div class="col-lg-8 col-12 ">
                            <small class="text-right mt-4" id="Lblreply">ریپلای (reply)</small>
                            <input @keypress="$ValidLenght($event, 250)" type="text" v-model="rep.reply"
                                class="form-control required" dir="rtl" />
                        </div>
                        <div class="col-lg-4 col-12" v-if="!isEdit">
                            <button class=" btn btn-success mt-4" @click="SaveReply()">ثـبـت</button>
                        </div>
                        <div class="col-lg-4 col-12" v-else>
                            <button class=" btn btn-warning  mt-4" @click="applyEdit()">ویرایش</button>
                        </div>
                    </div>

                </div>

                <BnpGrid Selectable :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true"
                    v-if="$store.state.renderComponentGrid">
                    <template slot="action-slot" slot-scope="props">

                        <a href="javascript:;" class="mr-2 badge" @click="getReply(props.props)" v-if="isCatsPage">
                            <h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6>
                        </a>
                        <!-- <a href="javascript:;" class="mr-2 badge" @click="addRoute(props.props)">
                            <h6><span class="fad fa-plus  hover-warning"></span></h6>
                        </a> -->
                        <a href="javascript:;" class="mr-2 badge" @click="edit(props.props)">
                            <h6><span class="fa fa-pencil-square-o hover-info"></span></h6>
                        </a>
                        <a href="javascript:;" class="mr-2 badge" @click="remove(props.props)">
                            <h6><span class="fa fa-times hover-danger"></span></h6>
                        </a>
                    </template>
                </BnpGrid>


            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";

export default {
    components: { Card, BnpGrid },
    data() {
        return {
            showAdd: false,
            isEdit: false,
            isCatsPage: true,
            DataaxiosDepUser: {
                Action: "TicketAnswer/B_GetCats",
                Method: "Get",
                ArryfildValue: null

            },
            propsRows: [],
            propsColumn: [
                { name: 'Name', label: 'نام', visibility: true },
            ],
            rep: {
                reply: null,
                subject: null
            },
            cat: {
                id: null,
                catName: '',
            },
            answerCatId: null,
            idForEdit: null,
            catsName: null,
            tblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId,
        };
    },
    created() {
        this.getCats()
    },
    methods: {
        getReply(props) {
            this.DataaxiosDepUser.Action = "TicketAnswer/B_GetReply"
            this.DataaxiosDepUser.Method = "Get"
            this.DataaxiosDepUser.ArryfildValue = {
                Id: props.Id
            }
            this.$GetData_Header(this.DataaxiosDepUser).then((res) => {
                this.propsRows = res
                this.propsColumn = [
                    { name: 'Subject', label: 'موضوع', visibility: true },
                    { name: 'Reply', label: 'ریپلای', visibility: true },
                ]
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                })
                this.isCatsPage = false
                this.answerCatId = props.Id
                this.catsName = props.Name
                this.nullRequierd()
                this.cansle()
            }).catch((err) => {
                this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000)
                console.error("CATCH", err);
            })
        },

        backToCatsPage() {
            this.getCats()
            this.propsColumn = [
                { name: 'Name', label: 'نام', visibility: true },
            ]
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
            })
            this.isCatsPage = true
            this.answerCatId = null
            this.catsName = null
        },

        getCats() {
            this.DataaxiosDepUser.Action = "TicketAnswer/B_GetCats"
            this.DataaxiosDepUser.Method = "Get"
            this.DataaxiosDepUser.ArryfildValue = null
            this.$PostData(this.DataaxiosDepUser).then((data) => {
                this.propsRows = data
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                })
                this.nullRequierd()
                this.cansle()
            }).catch((err) => {
                this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000)
                console.error("CATCH", err);
            })
        },

        SaveReply() {
            if (!this.isCatsPage && this.$ValidForm('menuForm')) {
                this.DataaxiosDepUser.Action = "TicketAnswer/B_AddReply"
                this.DataaxiosDepUser.Method = "Post"
                this.DataaxiosDepUser.ArryfildValue = {
                    AnswerCatId: this.answerCatId,
                    Subject: this.rep.subject,
                    Reply: this.rep.reply,
                    TblUserGrpIdInsert : this.tblUserGrpIdInsert
                }
                this.$PostData(this.DataaxiosDepUser).then((res) => {
                    var newReply = {
                        Id: res.returnId,
                        Subject: this.rep.subject,
                        AnswerCatId: this.answerCatId,
                        Reply: this.rep.reply,
                    }
                    this.showAdd=true
                    this.propsRows.push(newReply)
                    this.$store.state.renderComponentGrid = false;
                    this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })
                    this.$mySweetDefaultTost("عملیات موفق", "ریپلای با موفقیت افزوده شد", "success", 1000)
                    this.nullRequierd()
                })
            }
        },

        SaveCat() {
            if (this.isCatsPage && this.$ValidForm('menuForm')) {
                this.DataaxiosDepUser.Action = "TicketAnswer/B_AddCats"
                this.DataaxiosDepUser.Method = "Post"
                this.DataaxiosDepUser.ArryfildValue = {
                    Name: this.cat.catName,
                    TblUserGrpIdInsert : this.tblUserGrpIdInsert
                }
                this.$PostData(this.DataaxiosDepUser).then((res) => {
                    var newCat = {
                        Id: res.returnId,
                        Name: this.cat.catName
                    }
                    this.propsRows.push(newCat)
                    this.$store.state.renderComponentGrid = false;
                    this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                    })
                    this.$mySweetDefaultTost("عملیات موفق", "دسته جدید با موفقیت افزوده شد", "success", 1000)
                    this.nullRequierd()
                    this.cansle()
                }).catch((err) => {
                    this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000)
                    console.error("CATCH", err);
                })
            }

        },
        edit(props) {
            this.showAdd = true
            this.isEdit = true
            this.idForEdit = props.id
            if (this.isCatsPage) {
                this.cat.catName = props.Name
                this.$store.state.OldDataForLog = JSON.stringify(this.cat)
            } else {
                this.rep.reply = props.Reply
                this.rep.subject = props.Subject
                this.$store.state.OldDataForLog = JSON.stringify(this.rep)
            }
        },
        applyEdit() {
            if (this.$ValidForm('menuForm')) {
                if (this.isCatsPage) {
                    this.DataaxiosDepUser.Action = "TicketAnswer/b_UpdateCats"
                    this.DataaxiosDepUser.Method = "Put"
                    this.DataaxiosDepUser.ArryfildValue = {
                        Id: this.idForEdit,
                        Name: this.cat.catName,
                        TblUserGrpIdInsert : this.tblUserGrpIdInsert
                    }
                } else {
                    this.DataaxiosDepUser.Action = "TicketAnswer/b_UpdateReply"
                    this.DataaxiosDepUser.Method = "Put"
                    this.DataaxiosDepUser.ArryfildValue = {
                        Id: this.idForEdit,
                        Subject: this.rep.subject,
                        Reply: this.rep.reply,
                        TblUserGrpIdInsert : this.tblUserGrpIdInsert
                    }
                }
                this.$PostData(this.DataaxiosDepUser).then((res) => {
                    if (res.status == "Ok") {
                        var record = this.propsRows.find(element => element.Id == this.idForEdit)
                        if (this.isCatsPage) {
                            record.Name = this.cat.catName
                            this.$SetLog(this.cat, 0)

                        } else {
                            record.Subject = this.rep.subject
                            record.Reply = this.rep.reply
                            this.$SetLog(this.rep, 0)
                        }
                        this.$store.state.renderComponentGrid = false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true
                        })
                        this.nullRequierd()
                        this.cansle()
                        this.$mySweetDefaultTost("عملیات موفق", "ویرایش با موفقیت انجام شد", "success", 1000)

                    } else {
                        this.$mySweetDefaultTost("عملیات ناموفق", "دسته بندی پیدا نشد", "error", 1500)
                    }

                }).catch((err) => {
                    this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000)
                    console.error("CATCH", err);
                })
            }

        },

        remove(props) {
            if (this.isCatsPage) {
                this.cat.catName = props.Name
                this.$store.state.OldDataForLog = JSON.stringify(this.cat)
            } else {
                this.rep.reply = props.Reply
                this.rep.subject = props.Subject
                this.$store.state.OldDataForLog = JSON.stringify(this.rep)
            }
            const swalWithBootstrapButtons = this.$swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success mx-1',
                    cancelButton: 'btn btn-danger'
                },
                buttonsStyling: false
            })
            var name = this.isCatsPage ? props.Name : props.Subject

            swalWithBootstrapButtons.fire({
                title: 'اطمینان دارید؟',
                text: 'از حذف ' + '<' + name + '>' + '؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'بله، حذف شود',
                cancelButtonText: 'لغو',
                reverseButtons: false
            }).then((result) => {

                if (result.isConfirmed) {

                    this.DataaxiosDepUser.Action = this.isCatsPage ? "TicketAnswer/B_DelteCats" : "TicketAnswer/B_DelteReply"
                    this.DataaxiosDepUser.Method = "Delete"
                    this.DataaxiosDepUser.ArryfildValue = {
                        Id: props.Id
                    }
                    this.$PostData(this.DataaxiosDepUser).then((res) => {
                        if (res.status == "Ok") {
                            var record = this.propsRows.find(x => x.Id == props.Id)
                            var index = this.propsRows.indexOf(record)
                            this.propsRows.splice(index, 1);

                            if (this.isCatsPage) {
                                this.$SetLog(this.cat, 1)
                            } else {
                                this.$SetLog(this.rep, 1)
                            }
                            
                            this.$store.state.renderComponentGrid = false;
                            this.$nextTick(() => {
                                this.$store.state.renderComponentGrid = true
                            })
                            this.$toasted.success("حذف با موفقیت صورت گرفت", {
                            action: {
                                text: "بستن",
                                onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                                },
                            },
                            });
                        }
                        else if (res.status == "HasChild") {
                            swalWithBootstrapButtons.fire(
                                '',
                                'آیتم دارای زیرمجوعه است امکان حذف نیست',
                                'info'
                            )
                        }
                        else {
                            swalWithBootstrapButtons.fire(
                                '',
                                "خطایی رخ داد",
                                'error'
                            )
                        }
                    }).catch((err) => {
                        swalWithBootstrapButtons.fire(
                            '',
                            'عملیات با خطا مواجه شد',
                            'error'
                        )
                        console.error("CATCH", err)
                    })
                }
            })
        },

        cansle() {
            this.showAdd = false
            this.isEdit = false
        },
        fasClick() {
            this.showAdd = !this.showAdd
            this.isEdit = false
            this.nullRequierd()
        },
        nullRequierd() {
            this.rep.reply = null
            this.rep.subject = null
            this.cat.id = null
            this.cat.catName = null
            this.idForEdit = null
        }
    }
}
</script>
<style scoped>
button.btn {
    color: var(--sidebar-color-item);
}
</style>